import React from "react";
import { Paragraph } from "common/components/Typography";

export interface LabelProps {
  htmlFor: string;
  title: string;
}

export const Label: React.FC<LabelProps> = (props) => (
  <Paragraph withSpacing>
    <label htmlFor={props.htmlFor}>{props.title}</label>
  </Paragraph>
);
